export class HttpStatusCode{
    public static ok:number = 200;
    public static noContent:number = 204;
    public static badRequest:number = 400;
    public static unauthorized:number = 401;
    public static forbidden:number = 403;
    public static notFound:number = 404;
    public static methodNotAllowed:number = 405;
    public static internalServerError:number = 500;
    public static notImplemented:number = 501;
    public static badGateway:number = 502;
    public static serviceUnavailable:number = 503;
    public static gatewayTimeout:number = 504;
}


// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/models/http-status-code.constants.ts